<template>
  <div class="flex flex-col lg:flex-row w-full justify-between items-center mt-4 relative">
    <nav class="flex items-start lg:w-1/3 w-11/12 justify-between z-20">
      <router-link :to="dashboardPath">
        <img :src="profilePic ? profilePic : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png'"
        class="rounded-full border-2 w-8 lg:w-11 my-7"
        :class="$route.fullPath === dashboardPath
        ? 'border-'+textColor : 'hover:border-'+textColor">
      </router-link>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'>
          {{$t('messages.message')}}
        </span>
        <messages-to-read :dashboardPath="dashboardPath" :textColor="textColor" />
      </div>
      <div class='has-tooltip my-8 w-8'>
        <span class='tooltip'>
          {{$t('dashboard.calendar')}}
        </span>
        <router-link :to="dashboardPath+'/calendar'">
          <calendar-icon
          :class="$route.fullPath === dashboardPath+'/calendar' ?
          'text-'+textColor : 'hover:text-'+textColor" />
        </router-link>
      </div>
      <router-link :to="dashboardPath+'/reviews'" class="my-8 w-8 ml-2"
        v-if="isTeacher">
        <reviews-icon
        :class="$route.fullPath === dashboardPath+'/reviews' ?
        'text-'+textColor : 'hover:text-'+textColor" />
      </router-link>
      <router-link :to="dashboardPath+'/payment-methods'" class="my-8 w-8 ml-2"
        v-else>
        <payments-icon
        :class="$route.fullPath === dashboardPath+'/payment-methods' ?
        'text-'+textColor : 'hover:text-'+textColor" />
      </router-link>
      <router-link class="hover:text-background-academy text-grey-academy-250 hidden md:flex my-8"
        :to="dashboardPath+'/timezones'">
          <settings-icon class="w-8 text-grey-academy-300"/>
      </router-link>
    </nav>
    <div class="w-full lg:w-1/2">
      <language-and-timezone />
    </div>
  </div>
</template>

<script>
import MessagesToRead from '@/components/graphics/MessagesToRead.vue';
import { mapGetters } from 'vuex';
import CalendarIcon from './CalendarIcon.vue';
import ReviewsIcon from './ReviewsIcon.vue';
import PaymentsIcon from './PaymentsIcon.vue';
import LanguageAndTimezone from './LanguageAndTimezone.vue';
import SettingsIcon from './SettingsIcon.vue';

export default {
  props: ['profilePic'],

  components: {
    MessagesToRead,
    CalendarIcon,
    LanguageAndTimezone,
    ReviewsIcon,
    PaymentsIcon,
    SettingsIcon,
  },

  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),

    textColor() {
      if (this.isTeacher) {
        return 'beige-academy-300';
      }
      return 'orange-academy-300';
    },
  },

};
</script>

<style>
  .tooltip {
    @apply invisible absolute text-gray-500 text-xs mt-10 font-sans-serif;
  }

  .has-tooltip:hover .tooltip {
    @apply visible z-50;
  }
</style>
